<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{getRouteName($route.name)}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <!--           <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
              :md-open-on-focus="false"
            >
              <label v-if="$route.meta.rtlActive">بحث...</label>
              <label v-else>Search...</label>
            </md-autocomplete>
          </div>-->

          <md-list>

            <!-- WebSocket status idicator -->
            <md-list-item
              :title="[wsConnected ? $lang.general.ws_icon_connected : $lang.general.ws_icon_not_connected]"
            >
              <md-icon style="margin: 0px;">{{wsConnected ? 'cloud_queue' : 'cloud_off'}}</md-icon>
            </md-list-item>

            <!-- Applications section -->
            <md-list-item
              v-if="supportedApplications.length > 0"
              :title="$lang.tooltip.applications"
            >
              <router-link :to="{ name: 'applications_default'}">
                <i class="material-icons">apps</i>
                <p class="hidden-lg hidden-md">Dashboard</p>
              </router-link>
            </md-list-item>

          <!-- Notifications section -->
            <li class="md-list-item">
              <!-- <div class="md-list-item-content"> -->
              <drop-down direction="down">
                <md-button
                  slot="title"
                  class="md-button md-just-icon md-simple"
                  data-toggle="dropdown"
                  @click="notificationView"
                >
                  <md-icon>notifications</md-icon>
                  <span v-if="showNotificationCounter" class="notification">{{notificationCounter}}</span>
                  <p class="hidden-lg hidden-md">Notifications</p>
                </md-button>
                <ul class="dropdown-menu dropdown-menu-right">
                  <li v-for="item in notifications" v-bind:key="item.id">
                    <a v-if="item.type == 'STATUS'" href="#">
                      {{getFormattedTime(item.data.timestamp)}}
                      <br />
                      {{$lang.messages.device_status_change}} {{item.data.event}}
                    </a>

                    <a v-if="item.type == 'ANOMALY'" href="#">
                      {{getFormattedTime(item.data.timestamp)}}
                      <br />
                      {{item.data.message}}
                    </a>

                    <a v-if="item.type == 'NILM' && item.data.event == 'ON'" href="#">
                      {{getFormattedTime(item.data.timestamp)}}: {{$lang.general.appliance_on}}
                      <br />
                      {{item.data.name}}
                      <br />
                      {{$lang.charts.phase}} {{item.data.phase}}
                    </a>

                    <a v-if="item.type == 'NILM' && item.data.event == 'OFF'" href="#">
                      {{getFormattedTime(item.data.timestamp)}}: {{$lang.general.appliance_off}}
                      <br />
                      {{item.data.name}}
                      <br />
                      {{$lang.charts.phase}} {{item.data.phase}}
                      <br />
                      {{$lang.general.energy_consumption}} {{Number(item.data.energy_consumption_wh).toFixed(1)}} Wh
                    </a>

                    <a v-if="item.type == 'DISCONNECTOR'" href="#">
                      {{getFormattedTime(item.data.timestamp)}} | Disconnector
                      <br />
                      {{item.data.event === 'ON' ? $lang.messages.turn_on_relay : $lang.messages.turn_off_relay}} {{' ' + item.data.name}}
                      <br />
                    </a>
                  </li>
                </ul>
              </drop-down>
              <!-- </div> -->
            </li>

            <!--               <li class="md-list-item">
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <img :src="getSelectedLocation()" />
                    </md-button>
                      <ul class="dropdown-menu dropdown-menu-right">
                        <li><a href="#" @click="changeLocation('sk')"><img src="/img/flags/sk.png" class="location-flag" />{{this.$lang.general.slovak}}</a></li>
                        <li><a href="#" @click="changeLocation('en')"><img src="/img/flags/en.png" class="location-flag" />{{this.$lang.general.english}}</a></li>
                        <li><a href="#" @click="changeLocation('de')"><img src="/img/flags/de.png" class="location-flag" />{{this.$lang.general.deutsch}}</a></li>
                      </ul>
                  </drop-down>
                </div>
            </li>-->

            <!--     <drop-down>
      <md-list-item class="md-button md-simple md-just-icon dropdown-toggle">
          <img :src="getSelectedLocation()" />
      </md-list-item>
        
      <ul class="dropdown-menu dropdown-menu-right">
        <li><a href="#" @click="changeLocation('sk')"><img src="/img/flags/sk.png" class="location-flag" />{{this.$lang.general.slovak}}</a></li>
        <li><a href="#" @click="changeLocation('en')"><img src="/img/flags/en.png" class="location-flag" />{{this.$lang.general.english}}</a></li>
        <li><a href="#" @click="changeLocation('de')"><img src="/img/flags/de.png" class="location-flag" />{{this.$lang.general.deutsch}}</a></li>
      </ul>
    </drop-down> 


            -->

            <!--             <md-list-item href="#/pages/user">
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>-->
          </md-list>
        </div>
      </div>
    </div>
    <snack-bar ref="snackbar"></snack-bar>
  </md-toolbar>
</template>

<script>
import format from "date-fns/format";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar
  },
  data() {
    return {
      showNotificationCounter: false,
      notificationCounter: 0,
      offlineCounter: 0
    };
  },

  computed: {
    getLocation() {
      return this.$store.getters.getSettings.localization;
    },
    notifications() {
      return this.$store.getters.getNotificationList;
    },
    supportedApplications() {
      return this.$store.getters.getAuth.applications;
    },
    wsConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    notifications: function(payload, oldPayload) {
      this.showNotificationCounter = true;
      this.notificationCounter++;
    },
    wsConnected(newVal, oldVal) {
      if (newVal) {
        if (this.offlineCounter > 0) {
          this.offlineCounter = 0;
          this.$refs.snackbar.notify("You are online");
        }
      } else {
        this.offlineCounter++;
        this.$refs.snackbar.notify("You are currently offline");
      }
    }
  },

  methods: {
    getFormattedTime(timestamp) {
      return format(timestamp * 1000, "HH:mm:ss");
    },
    getRouteName(routeName) {
      return this.$lang.titles[routeName];
    },
    notificationView() {
      this.showNotificationCounter = false;
      this.notificationCounter = 0;
    },
    changeLocation(location) {
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    },
    getSelectedLocation() {
      return "/img/flags/" + this.getLocation + ".png";
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.location-flag {
  padding-right: 10px;
}

.wifi-online {
  color: #4caf50;
}

.wifi-offline {
  color: #df2869;
}
</style>
